<template>
  <div class="trust-and-safety-sign-up">
    <p class="px-16 py-16">
      All users are encouraged to visit our
      <a class="underline" target="_blank" href="https://www.sittercity.com/trust-and-safety">Trust & Safety Center</a>
      to learn more about our commitment to keeping you safe.
    </p>
  </div>
</template>

<script>
export default {
  name: 'PoppinsTrustAndSafety',
};
</script>

<style lang="scss">
.trust-and-safety-sign-up {
  background-color: #ddf3ff;
  color: #005988;
  max-width: 448px;
  margin-top: 24px;
  font-size: 14px;
  line-height: 21px;
  border-radius: 4px;

  @media (min-width: 480px) {
    margin-right: auto;
    margin-left: auto;
  }
}
</style>
